<template>
    <tr>
        <td class="editor-content editor-label">Border</td>
        <td class="editor-content">
            <select class="form-control editor-form editor-select" v-model="selectedComponent.border">
                <option>none</option>
                <option>rounded</option>
                <option>circle</option>
                <option>pill</option>
            </select>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'ImageBorderSelector',
        props: ['selectedComponent'],
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
